<h1 mat-dialog-title>{{"Please Confirm" | cmLocalize: "Core/System.ContinueModal.Title.Confirm"}}</h1>
<div mat-dialog-content>
	<p>{{"Are you sure you want to continue?" | cmLocalize: "Core/System.ContinueModal.Content.Message"}}</p>
</div>

<div mat-dialog-actions>
	<button mat-dialog-close>
		{{"Cancel" | cmLocalize: "Core/System.ContinueModal.Button.Cancel"}}
	</button>
	<button [mat-dialog-close]="true" color="primary" cdkFocusInitial>
		{{"Confirm" | cmLocalize: "Core/System.ContinueModal.Button.Confirm"}}
	</button>
</div>
